import { Link } from '@remix-run/react';
import { buttonVariants } from '~/components/ui/button';

interface Props {
  to: string;
  label: string;
}

export const ReadMoreButton = ({to, label}: Props) => {
  return (
    <div className='flex flex-col justify-center items-center'>
      <Link
        to={to}
        className={`${buttonVariants({
          variant: 'secondary',
          size: 'lg'
        })} font-semibold min-w-[300px]`}
      >
        {label}
      </Link>
    </div>
  );
};
